import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mark-pneu-detail',
  templateUrl: './mark-pneu-detail.component.html',
  styleUrls: ['./mark-pneu-detail.component.scss']
})
export class MarkPneuDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
